import getDistance from 'geolib/es/getDistance'

const GATSBY_LARGE_BOUNDS_MIN_DISTANCE_METERS = 20000

export const checkForLargeBounds = bounds => {
  if (!bounds) return false
  const distance = getDistance(bounds.ne, bounds.sw)
  return distance > GATSBY_LARGE_BOUNDS_MIN_DISTANCE_METERS
}
